import { ENDPOINTS } from 'src/constants/endpoints'

import DateAdapter from 'src/app/core/adapters/date/DateAdapter'

import type { IInsightEntity } from '../../types'
import type { IMemberInsightItemDTO } from '../contracts/member-insights'

const stripFileExtension = (fileName: string): string =>
  fileName.replace(/\.[^./\\]+$/, '')

export const mapMemberInsightItem = (
  dto: IMemberInsightItemDTO,
): IInsightEntity => ({
  id: dto.id,
  reportName: stripFileExtension(dto.file_name),
  category: dto.category,
  contentCoverage: dto.coverage,
  producer: dto.producers,
  releaseDate: DateAdapter.formatReleaseDate(dto.release_date),
  downloadUrl: ENDPOINTS.hanwha.memberInsightDownload(dto.id),
})
